import { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { resetStatusState } from "../slices/statusSlice";

export const useTimerAlert = (alert) => {
  const dispatch = useDispatch()
  const [timer, setTimer] = useState(null)
  const handleTimer = () => {
    if(alert) {
      setTimer(
        setTimeout(() => {
          // dispatch(resetStatusState())
          // console.log("ERROR----------------------->")
       }, 5000)
      )
    }

  }

  return { timer, handleTimer }
}